module.exports = window.wp.element;